import React from 'react';
import ReactWordcloud from 'react-wordcloud';
import 'tippy.js/dist/tippy.css';
import 'tippy.js/animations/scale.css';

/**
 * Word Cloud Chart Component
 * Renders interactive word clouds with tooltips
 */
const WordCloudChart = ({ data, width = 600, height = 400, onWordClick }) => {
  if (!data || data.length === 0) {
    return (
      <div style={{
        width: '100%',
        height: height,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: '#9ca3af',
        fontSize: '14px'
      }}>
        No text data available for word cloud
      </div>
    );
  }

  // Word cloud options
  const options = {
    colors: [
      '#2563eb', // Blue
      '#7c3aed', // Purple
      '#db2777', // Pink
      '#dc2626', // Red
      '#ea580c', // Orange
      '#16a34a', // Green
      '#0891b2', // Cyan
      '#4f46e5', // Indigo
    ],
    enableTooltip: true,
    deterministic: true,
    fontFamily: 'system-ui, -apple-system, sans-serif',
    fontSizes: [14, 72],
    fontStyle: 'normal',
    fontWeight: 'bold',
    padding: 2,
    rotations: 2,
    rotationAngles: [0, 90],
    scale: 'sqrt',
    spiral: 'archimedean',
    transitionDuration: 1000
  };

  const callbacks = {
    onWordClick: onWordClick || ((word) => {
      console.log('Word clicked:', word);
    }),
    getWordTooltip: (word) =>
      `"${word.text}" appears ${word.value} time${word.value > 1 ? 's' : ''}`
  };

  return (
    <div style={{ width: '100%', height: height }}>
      <ReactWordcloud
        words={data}
        options={options}
        callbacks={callbacks}
      />
    </div>
  );
};

export default WordCloudChart;
